<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Media</h2>
        <v-btn color="primary" size="small" @click="$router.push('/media/new')">Nuovo</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.name" label="Nome" clearable></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select  v-model="query.media" label="Tipologia" clearable :items="mediaTypeOptions"></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="media" view-sub-path="" :viewable="false" :editable="true" deletable :query="query" @error="onListError">
          <template v-slot:item.name="{ item }">
            <a @click="$router.push('/media/'+item._id)" ><strong>{{ item.name }}</strong></a>
          </template>

          <template v-slot:item.media="{ item }">
            <v-chip v-if="item.media === 'cover'" color="deep-purple-lighten-1">copertina</v-chip>
            <v-chip v-else-if="item.media==='icon'" color="teal-darken-1">icona</v-chip>
            <v-chip v-else-if="item.media==='gallery'" color="amber-darken-1">galleria</v-chip>
            <v-chip v-else-if="item.media==='banner'" color="lime-darken-3">banner</v-chip>
            <v-chip v-else-if="item.media==='audio'" color="red-lighten-2">audio</v-chip>
            <v-chip v-else-if="item.media==='video'" color="blue-darken-1">video</v-chip>
            <v-chip v-else color="blue-grey-darken-1">{{item.media}}</v-chip>
          </template>
          <template v-slot:item.url="{ item }">
            <a :href="item.url" target="_blank">vedi</a>
          </template>

          <template v-slot:item.pub="{ item }">
            <strong class="text-success" v-if="item.pub">Sì</strong>
            <span class="text-error" v-else>No</span>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";
import {mediatypes} from "@/consts.ts";


export default defineComponent({
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()
    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})


    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      /*
      await Promise.all([
        globals.refresh('categories'),
        globals.refresh('difficulties'),
      ])*/

      query.value = utils.getSessionQuery("media")

      wh = watch(query.value, ()=>{
        utils.setSessionQuery("media", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      dataTable,
      formatDateTime : utils.formatDateTime,
      query,
      mediaTypeOptions : mediatypes,
      headers : [
        { title : 'Nome', sortable: true, align: 'left', value : 'name' },
        { title : 'Tipologia', sortable: true, align: 'left', value : 'media' },
        { title : 'Url', sortable: true, align: 'left', value : 'url' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
    }
  }
})
</script>
